module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Departmental-Exam/dept-exam-authorization/dept-exam-auth-form/dept-exam-auth-form.component.css
// module id = ./src/app/hrms/Departmental-Exam/dept-exam-authorization/dept-exam-auth-form/dept-exam-auth-form.component.css
// module chunks = main